import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Date from "../../../Components/Control/Date";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import Hospital from "../../../Server/Hospital";
import Notif from "../../../Components/Notif";
import {printerTemplate} from "../../../Printer";
import Check from "../../../Components/Control/Check";
import {updateBase} from "../../../Redux/Actions/base";
import ModalPrint from "../ModalPrint";
import MyComponent from '../../../Components/MyComponent';
import {HospitalOrgNormRequest, OrganizationOrgNormRequest} from '../../../Server/OrgNormRequest';

class ModalOrgNormRequest extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            error: false,
            loading: false,
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            insert: React.createRef(),
            update: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        // patientFirstName: x => Boolean(this.state?.patientFileInfo || x) || 'نام بیمار نمی‌تواند خالی باشد.',
    };

    componentDidMount() {


        Hospital.incomingList()
            .then(list => {
                const products = {};

                for (let item of list) {
                    if (!products[item.productTypeId]) {
                        products[item.productTypeId] = {count: 0, name: item.productTypeStr};
                    }
                    products[item.productTypeId].count++;
                }

                this.setInventory(products);

                this.setState({inventory: products});
            });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            props.base !== nextProps.base;
    }

    render() {
        const {state, props, ref} = this;
        const readOnly = state.action === ModalAction.VIEW;

        return <React.Fragment>
            <Modal ref={ref.modal}
                   name={'ModalOrgNormRequest'}
                   size={'large'}
                   title={'فرم درخواست فرآورده از سازمان'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <div className={'table-border'} style={{marginBottom: 10}}>
                        <table style={{textAlign: 'center'}}>
                            <tbody>
                            <tr style={{backgroundColor: '#bce1d5'}}>
                                <td colSpan={3}>
                                    <div className={'dis-f'}>
                                        <div className={'flex ali-c'} style={{fontSize: 15, fontWeight: 500}}>
                                            فرم درخواست خون و فرآورده‌های آن توسط بانک خون بیمارستان‌ها<br/>
                                            از واحد بخش خون پایگاه‌های انتقال خون
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{backgroundColor: '#bce1d5'}}>
                                <td/>
                                <td style={{fontSize: 11, fontWeight: 500}}>مسئول تکمیل فرم:</td>
                                <td/>
                            </tr>
                            <tr style={{backgroundColor: '#bce1d5'}}>
                                {/*<td style={{fontSize: 13, fontWeight: 500}}>1- مسئول بانک خون</td>*/}
                                <td style={{fontSize: 13, fontWeight: 500}}>1- مسئول بانک خون</td>
                                <td style={{fontSize: 13, fontWeight: 500}}>2- نماینده بیمارستان جهت تحویل گرفتن فرآورده از پایگاه</td>
                                <td style={{fontSize: 13, fontWeight: 500}}>3- فرد تحویل گیرنده فرآورده در بانک خون</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="table-border" style={{marginBottom: 10}}>
                        <table>
                            <tbody>
                            <tr>
                                <td className={'bb bl'}><Input className={'pad-4'} readOnly={true} label={'استان'} value={props.user?.provinceName}/></td>
                                <td className={'bb'}><Input className={'pad-4'} readOnly={true} label={'شهرستان'} value={props.user?.cityName}/></td>
                            </tr>
                            <tr>
                                <td className={' bl'}><Input className={'pad-4'} readOnly={true} label={'نام بیمارستان / مرکز درمانی'} value={props.user?.hospitalFullName || state.data?.hospitalFullName}/></td>
                                <td><Input className={'pad-4'} readOnly={true} label={'تاریخ و ساعت درخواست'} direction={'ltr'} align={'center'} value={moment().format('jYYYY/jMM/jDD')}/></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="table-border">
                        <table>
                            <tbody>
                            <tr>
                                <td className={'bb lab'} colSpan={13}>درخواست جهت تکمیل ذخیره بانک خون</td>
                            </tr>
                            <tr className={'bb lab'} style={{backgroundColor: '#e3f2e7'}}>
                                <td className={'bl verticalCell'} rowSpan={17} style={{backgroundColor: '#1eb26a', color: 'white', fontSize: 20, fontWeight: 500}}><p>تکمیل توسط مسئول بانک خون</p></td>
                                <td className={'bl'} style={{width: '170px'}}>خون و فرآورده‌های آن</td>
                                <td className={'bl'} style={{width: '5%'}}>+O</td>
                                <td className={'bl'} style={{width: '5%'}}>-O</td>
                                <td className={'bl'} style={{width: '5%'}}>+A</td>
                                <td className={'bl'} style={{width: '5%'}}>-A</td>
                                <td className={'bl'} style={{width: '5%'}}>+B</td>
                                <td className={'bl'} style={{width: '5%'}}>-B</td>
                                <td className={'bl'} style={{width: '5%'}}>+AB</td>
                                <td className={'bl'} style={{width: '5%'}}>-AB</td>
                                <td className={'bl'} style={{width: '5%'}}>جمع</td>
                                <td className={'bl'}>موجودی بانک خون</td>
                                <td>ملاحظات</td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>خون کامل (WB)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.o_POSCount} onChange={this.setField.bind(this, 'wbJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.o_NEGCount} onChange={this.setField.bind(this, 'wbJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.a_POSCount} onChange={this.setField.bind(this, 'wbJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.a_NEGCount} onChange={this.setField.bind(this, 'wbJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.b_POSCount} onChange={this.setField.bind(this, 'wbJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.b_NEGCount} onChange={this.setField.bind(this, 'wbJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.aB_POSCount} onChange={this.setField.bind(this, 'wbJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.aB_NEGCount} onChange={this.setField.bind(this, 'wbJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.wbJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.wbJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'wbJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.wbJson?.description} onChange={this.setField.bind(this, 'wbJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>گلبول قرمز متراکم (RBC)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.o_POSCount} onChange={this.setField.bind(this, 'rbcJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.o_NEGCount} onChange={this.setField.bind(this, 'rbcJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.a_POSCount} onChange={this.setField.bind(this, 'rbcJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.a_NEGCount} onChange={this.setField.bind(this, 'rbcJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.b_POSCount} onChange={this.setField.bind(this, 'rbcJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.b_NEGCount} onChange={this.setField.bind(this, 'rbcJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.aB_POSCount} onChange={this.setField.bind(this, 'rbcJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.aB_NEGCount} onChange={this.setField.bind(this, 'rbcJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.rbcJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.rbcJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'rbcJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.rbcJson?.description} onChange={this.setField.bind(this, 'rbcJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>گلبول قرمز کم لکوسیت (LRBC)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.o_POSCount} onChange={this.setField.bind(this, 'lrbcJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.o_NEGCount} onChange={this.setField.bind(this, 'lrbcJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.a_POSCount} onChange={this.setField.bind(this, 'lrbcJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.a_NEGCount} onChange={this.setField.bind(this, 'lrbcJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.b_POSCount} onChange={this.setField.bind(this, 'lrbcJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.b_NEGCount} onChange={this.setField.bind(this, 'lrbcJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.aB_POSCount} onChange={this.setField.bind(this, 'lrbcJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.aB_NEGCount} onChange={this.setField.bind(this, 'lrbcJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.lrbcJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.lrbcJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'lrbcJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrbcJson?.description} onChange={this.setField.bind(this, 'lrbcJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>کیسه اطفال (Pediatric RBC)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.o_POSCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.o_NEGCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.a_POSCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.a_NEGCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.b_POSCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.b_NEGCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.aB_POSCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.aB_NEGCount} onChange={this.setField.bind(this, 'pediatrictRBCJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.pediatrictRBCJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.pediatrictRBCJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'pediatrictRBCJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pediatrictRBCJson?.description} onChange={this.setField.bind(this, 'pediatrictRBCJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>پلاکت (PLT)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.o_POSCount} onChange={this.setField.bind(this, 'pltJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.o_NEGCount} onChange={this.setField.bind(this, 'pltJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.a_POSCount} onChange={this.setField.bind(this, 'pltJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.a_NEGCount} onChange={this.setField.bind(this, 'pltJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.b_POSCount} onChange={this.setField.bind(this, 'pltJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.b_NEGCount} onChange={this.setField.bind(this, 'pltJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.aB_POSCount} onChange={this.setField.bind(this, 'pltJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.aB_NEGCount} onChange={this.setField.bind(this, 'pltJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.pltJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.pltJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'pltJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.pltJson?.description} onChange={this.setField.bind(this, 'pltJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>پلاکت کم لکوسیت (LRPLT)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.o_POSCount} onChange={this.setField.bind(this, 'lrpltJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.o_NEGCount} onChange={this.setField.bind(this, 'lrpltJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.a_POSCount} onChange={this.setField.bind(this, 'lrpltJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.a_NEGCount} onChange={this.setField.bind(this, 'lrpltJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.b_POSCount} onChange={this.setField.bind(this, 'lrpltJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.b_NEGCount} onChange={this.setField.bind(this, 'lrpltJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.aB_POSCount} onChange={this.setField.bind(this, 'lrpltJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.aB_NEGCount} onChange={this.setField.bind(this, 'lrpltJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.lrpltJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.lrpltJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'lrpltJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.lrpltJson?.description} onChange={this.setField.bind(this, 'lrpltJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>پلاسمای تازه منجمد (FFP)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.o_POSCount} onChange={this.setField.bind(this, 'ffpJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.o_NEGCount} onChange={this.setField.bind(this, 'ffpJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.a_POSCount} onChange={this.setField.bind(this, 'ffpJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.a_NEGCount} onChange={this.setField.bind(this, 'ffpJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.b_POSCount} onChange={this.setField.bind(this, 'ffpJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.b_NEGCount} onChange={this.setField.bind(this, 'ffpJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.aB_POSCount} onChange={this.setField.bind(this, 'ffpJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.aB_NEGCount} onChange={this.setField.bind(this, 'ffpJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.ffpJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.ffpJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'ffpJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.ffpJson?.description} onChange={this.setField.bind(this, 'ffpJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>پلاسمای بدون کرایو (CPP)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.o_POSCount} onChange={this.setField.bind(this, 'cppJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.o_NEGCount} onChange={this.setField.bind(this, 'cppJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.a_POSCount} onChange={this.setField.bind(this, 'cppJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.a_NEGCount} onChange={this.setField.bind(this, 'cppJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.b_POSCount} onChange={this.setField.bind(this, 'cppJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.b_NEGCount} onChange={this.setField.bind(this, 'cppJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.aB_POSCount} onChange={this.setField.bind(this, 'cppJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.aB_NEGCount} onChange={this.setField.bind(this, 'cppJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.cppJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.cppJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'cppJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cppJson?.description} onChange={this.setField.bind(this, 'cppJson.description')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>کرایو (CRYO)</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.o_POSCount} onChange={this.setField.bind(this, 'cryJson.o_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.o_NEGCount} onChange={this.setField.bind(this, 'cryJson.o_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.a_POSCount} onChange={this.setField.bind(this, 'cryJson.a_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.a_NEGCount} onChange={this.setField.bind(this, 'cryJson.a_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.b_POSCount} onChange={this.setField.bind(this, 'cryJson.b_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.b_NEGCount} onChange={this.setField.bind(this, 'cryJson.b_NEGCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.aB_POSCount} onChange={this.setField.bind(this, 'cryJson.aB_POSCount')}/></td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.aB_NEGCount} onChange={this.setField.bind(this, 'cryJson.aB_NEGCount')}/></td>
                                <td className={'bl lab'}>{state?.fields?.cryJson?.sum}</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} value={state?.fields?.cryJson?.inventory} readOnly={true} onChange={this.setField.bind(this, 'cryJson.inventory')}/></td>
                                <td><Input className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.cryJson?.description} onChange={this.setField.bind(this, 'cryJson.description')}/></td>
                            </tr>
                            <tr>
                                <td colSpan={13} className={'lab bb'}>درخواست تحویل فرآورده‌های اختصاصی *</td>
                            </tr>
                            <tr className={'lab bb'} style={{backgroundColor: '#e3f2e7'}}>
                                <td className={'bl'} colSpan={2}>نام فرآورده</td>
                                <td className={'bl'} colSpan={2}>اشعه داده شده</td>
                                <td className={'bl'} colSpan={2}>شسته شده</td>
                                <td className={'bl'} colSpan={4}>CMV (Ag) Negative</td>
                                <td className={'bl'}>Pooled PLT</td>
                                <td>تاریخ تزریق</td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} colSpan={2}>الف- فرآورده‌های اختصاصی RBC</td>
                                <td className={'bl'} colSpan={2}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialRBCJson?.radiatedCount} onChange={this.setField.bind(this, 'specialRBCJson.radiatedCount')}/></td>
                                <td className={'bl'} colSpan={2}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialRBCJson?.wahsedCount} onChange={this.setField.bind(this, 'specialRBCJson.wahsedCount')}/></td>
                                <td className={'bl'} colSpan={4}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialRBCJson?.cmV_NEGCount} onChange={this.setField.bind(this, 'specialRBCJson.cmV_NEGCount')}/></td>
                                <td className={'bl lab'} style={{backgroundColor: '#e3f2e7'}}>----------------------</td>
                                <td><Date className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialRBCJson?.injectionDateTime} onChange={this.setField.bind(this, 'specialRBCJson.injectionDateTime')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} colSpan={2}>ب- فرآورده‌های اختصاصی پلاکت</td>
                                <td className={'bl'} colSpan={2}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialPLTJson?.radiatedCount} onChange={this.setField.bind(this, 'specialPLTJson.radiatedCount')}/></td>
                                <td className={'bl'} colSpan={2}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialPLTJson?.wahsedCount} onChange={this.setField.bind(this, 'specialPLTJson.wahsedCount')}/></td>
                                <td className={'bl lab'} colSpan={4} style={{backgroundColor: '#e3f2e7'}}>----------------------</td>
                                <td className={'bl'}><Input type={'number'} className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialPLTJson?.pooledPLTCount} onChange={this.setField.bind(this, 'specialPLTJson.pooledPLTCount')}/></td>
                                <td><Date className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.specialPLTJson?.injectionDateTime} onChange={this.setField.bind(this, 'specialPLTJson.injectionDateTime')}/></td>
                            </tr>
                            <tr className={'bb'}>
                                <td className={'bl lab'} colSpan={2}>ج- سایر فرآورده‌های اختصاصی</td>
                                <td className={'bl'} colSpan={9}><Input className={'pad-4'} value={state?.fields?.otherSpecialProductJson?.description} readOnly={readOnly} onChange={this.setField.bind(this, 'otherSpecialProductJson.description')}/></td>
                                <td><Date className={'pad-4'} align={"center"} readOnly={readOnly} value={state?.fields?.otherSpecialProductJson?.injectionDateTime} onChange={this.setField.bind(this, 'otherSpecialProductJson.injectionDateTime')}/></td>
                            </tr>
                            <tr className={'lab'}>
                                <td colSpan={13}>* برای درخواست این فرآورده‌ها باید از قبل با واحد پخش پایگاه انتقال خون هماهنگی شود.</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </ModalContent>
                <ModalControls>
                    {state.action === ModalAction.INSERT && <Check className={'mar-4'} label={'چاپ خودکار'} checked={props.base.orgRequestFormPrintOnSubmit} onChange={this.requestPrintOnSubmit.bind(this)}/>}
                    {state.action === ModalAction.INSERT && <Button refer={ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت درخواست</Button>}
                    <Button refer={ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={ref.modalPrint}/>
        </React.Fragment>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'wbJson':
            case 'rbcJson':
            case 'lrbcJson':
            case 'pediatrictRBCJson':
            case 'pltJson':
            case 'lrpltJson':
            case 'ffpJson':
            case 'cppJson':
            case 'cryJson':
                nextFields[keys[0]].sum = parseInt(nextFields[keys[0]]?.o_POSCount || 0) + parseInt(nextFields[keys[0]]?.o_NEGCount || 0) + parseInt(nextFields[keys[0]]?.a_POSCount || 0) + parseInt(nextFields[keys[0]]?.a_NEGCount || 0) + parseInt(nextFields[keys[0]]?.b_POSCount || 0) + parseInt(nextFields[keys[0]]?.b_NEGCount || 0) + parseInt(nextFields[keys[0]]?.aB_POSCount || 0) + parseInt(nextFields[keys[0]]?.aB_NEGCount || 0) || '';
                break;
            default:
        }
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});
            HospitalOrgNormRequest.insert({
                wbJson: {
                    o_POSCount: state?.fields?.wbJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.wbJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.wbJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.wbJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.wbJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.wbJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.wbJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.wbJson?.aB_NEGCount || 0,
                    sum: state?.fields?.wbJson?.sum || 0,
                    inventory: state?.fields?.wbJson?.inventory || 0,
                    description: state?.fields?.wbJson?.description || ''
                },
                rbcJson: {
                    o_POSCount: state?.fields?.rbcJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.rbcJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.rbcJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.rbcJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.rbcJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.rbcJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.rbcJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.rbcJson?.aB_NEGCount || 0,
                    sum: state?.fields?.rbcJson?.sum || 0,
                    inventory: state?.fields?.rbcJson?.inventory || 0,
                    description: state?.fields?.rbcJson?.description || ''
                },
                lrbcJson: {
                    o_POSCount: state?.fields?.lrbcJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.lrbcJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.lrbcJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.lrbcJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.lrbcJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.lrbcJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.lrbcJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.lrbcJson?.aB_NEGCount || 0,
                    sum: state?.fields?.lrbcJson?.sum || 0,
                    inventory: state?.fields?.lrbcJson?.inventory || 0,
                    description: state?.fields?.lrbcJson?.description || ''
                },
                pediatrictRBCJson: {
                    o_POSCount: state?.fields?.pediatrictRBCJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.pediatrictRBCJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.pediatrictRBCJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.pediatrictRBCJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.pediatrictRBCJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.pediatrictRBCJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.pediatrictRBCJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.pediatrictRBCJson?.aB_NEGCount || 0,
                    sum: state?.fields?.pediatrictRBCJson?.sum || 0,
                    inventory: state?.fields?.pediatrictRBCJson?.inventory || 0,
                    description: state?.fields?.pediatrictRBCJson?.description || ''
                },
                pltJson: {
                    o_POSCount: state?.fields?.pltJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.pltJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.pltJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.pltJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.pltJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.pltJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.pltJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.pltJson?.aB_NEGCount || 0,
                    sum: state?.fields?.pltJson?.sum || 0,
                    inventory: state?.fields?.pltJson?.inventory || 0,
                    description: state?.fields?.pltJson?.description || ''
                },
                lrpltJson: {
                    o_POSCount: state?.fields?.lrpltJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.lrpltJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.lrpltJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.lrpltJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.lrpltJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.lrpltJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.lrpltJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.lrpltJson?.aB_NEGCount || 0,
                    sum: state?.fields?.lrpltJson?.sum || 0,
                    inventory: state?.fields?.lrpltJson?.inventory || 0,
                    description: state?.fields?.lrpltJson?.description || ''
                },
                ffpJson: {
                    o_POSCount: state?.fields?.ffpJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.ffpJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.ffpJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.ffpJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.ffpJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.ffpJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.ffpJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.ffpJson?.aB_NEGCount || 0,
                    sum: state?.fields?.ffpJson?.sum || 0,
                    inventory: state?.fields?.ffpJson?.inventory || 0,
                    description: state?.fields?.ffpJson?.description || ''
                },
                cppJson: {
                    o_POSCount: state?.fields?.cppJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.cppJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.cppJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.cppJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.cppJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.cppJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.cppJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.cppJson?.aB_NEGCount || 0,
                    sum: state?.fields?.cppJson?.sum || 0,
                    inventory: state?.fields?.cppJson?.inventory || 0,
                    description: state?.fields?.cppJson?.description || ''
                },
                cryJson: {
                    o_POSCount: state?.fields?.cryJson?.o_POSCount || 0,
                    o_NEGCount: state?.fields?.cryJson?.o_NEGCount || 0,
                    a_POSCount: state?.fields?.cryJson?.a_POSCount || 0,
                    a_NEGCount: state?.fields?.cryJson?.a_NEGCount || 0,
                    b_POSCount: state?.fields?.cryJson?.b_POSCount || 0,
                    b_NEGCount: state?.fields?.cryJson?.b_NEGCount || 0,
                    aB_POSCount: state?.fields?.cryJson?.aB_POSCount || 0,
                    aB_NEGCount: state?.fields?.cryJson?.aB_NEGCount || 0,
                    sum: state?.fields?.cryJson?.sum || 0,
                    inventory: state?.fields?.cryJson?.inventory || 0,
                    description: state?.fields?.cryJson?.description || ''
                },
                specialRBCJson: {
                    radiatedCount: state?.fields?.specialRBCJson?.radiatedCount || 0,
                    wahsedCount: state?.fields?.specialRBCJson?.wahsedCount || 0,
                    cmV_NEGCount: state?.fields?.specialRBCJson?.cmV_NEGCount || 0,
                    injectionDateTime: state?.fields?.specialRBCJson?.injectionDateTime ? state?.fields?.specialRBCJson?.injectionDateTime.format() : null
                },
                specialPLTJson: {
                    radiatedCount: state?.fields?.specialPLTJson?.radiatedCount || 0,
                    wahsedCount: state?.fields?.specialPLTJson?.wahsedCount || 0,
                    pooledPLTCount: state?.fields?.specialPLTJson?.pooledPLTCount || 0,
                    injectionDateTime: state?.fields?.specialPLTJson?.injectionDateTime ? state?.fields?.specialPLTJson?.injectionDateTime.format() : null
                },
                otherSpecialProductJson: {
                    description: state?.fields?.otherSpecialProductJson?.description || '',
                    injectionDateTime: state?.fields?.otherSpecialProductJson?.injectionDateTime ? state?.fields?.otherSpecialProductJson?.injectionDateTime.format() : null
                }
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);

                this.close(true);

                if (this.props.base.orgRequestFormPrintOnSubmit)
                    this.print(state.fields || {});
            }).catch(message => {
                ref.insert.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                error: null
            }, _ => {
                this.setInventory();
            });
        } else if (action === ModalAction.UPDATE || action === ModalAction.VIEW) {
            this.setState({
                data,
                action,
                fields: {},
                loading: 'در حال دریافت اطلاعات درخواست'
            });

            OrganizationOrgNormRequest.data({hospitalRequestId: data.hospitalRequestId})
                .then(data => {
                    this.setState({
                        loading: null,
                        fields: {
                            data:{
                                ...this.state.data,
                                ...data
                            },
                            wbJson: {
                                o_POSCount: data?.wbJson?.o_POSCount || '',
                                o_NEGCount: data?.wbJson?.o_NEGCount || '',
                                a_POSCount: data?.wbJson?.a_POSCount || '',
                                a_NEGCount: data?.wbJson?.a_NEGCount || '',
                                b_POSCount: data?.wbJson?.b_POSCount || '',
                                b_NEGCount: data?.wbJson?.b_NEGCount || '',
                                aB_POSCount: data?.wbJson?.aB_POSCount || '',
                                aB_NEGCount: data?.wbJson?.aB_NEGCount || '',
                                sum: data?.wbJson?.sum || '',
                                inventory: data?.wbJson?.inventory || '',
                                description: data?.wbJson?.description || ''
                            },
                            rbcJson: {
                                o_POSCount: data?.rbcJson?.o_POSCount || '',
                                o_NEGCount: data?.rbcJson?.o_NEGCount || '',
                                a_POSCount: data?.rbcJson?.a_POSCount || '',
                                a_NEGCount: data?.rbcJson?.a_NEGCount || '',
                                b_POSCount: data?.rbcJson?.b_POSCount || '',
                                b_NEGCount: data?.rbcJson?.b_NEGCount || '',
                                aB_POSCount: data?.rbcJson?.aB_POSCount || '',
                                aB_NEGCount: data?.rbcJson?.aB_NEGCount || '',
                                sum: data?.rbcJson?.sum || '',
                                inventory: data?.rbcJson?.inventory || '',
                                description: data?.rbcJson?.description || ''
                            },
                            lrbcJson: {
                                o_POSCount: data?.lrbcJson?.o_POSCount || '',
                                o_NEGCount: data?.lrbcJson?.o_NEGCount || '',
                                a_POSCount: data?.lrbcJson?.a_POSCount || '',
                                a_NEGCount: data?.lrbcJson?.a_NEGCount || '',
                                b_POSCount: data?.lrbcJson?.b_POSCount || '',
                                b_NEGCount: data?.lrbcJson?.b_NEGCount || '',
                                aB_POSCount: data?.lrbcJson?.aB_POSCount || '',
                                aB_NEGCount: data?.lrbcJson?.aB_NEGCount || '',
                                sum: data?.lrbcJson?.sum || '',
                                inventory: data?.lrbcJson?.inventory || '',
                                description: data?.lrbcJson?.description || ''
                            },
                            pediatrictRBCJson: {
                                o_POSCount: data?.pediatrictRBCJson?.o_POSCount || '',
                                o_NEGCount: data?.pediatrictRBCJson?.o_NEGCount || '',
                                a_POSCount: data?.pediatrictRBCJson?.a_POSCount || '',
                                a_NEGCount: data?.pediatrictRBCJson?.a_NEGCount || '',
                                b_POSCount: data?.pediatrictRBCJson?.b_POSCount || '',
                                b_NEGCount: data?.pediatrictRBCJson?.b_NEGCount || '',
                                aB_POSCount: data?.pediatrictRBCJson?.aB_POSCount || '',
                                aB_NEGCount: data?.pediatrictRBCJson?.aB_NEGCount || '',
                                sum: data?.pediatrictRBCJson?.sum || '',
                                inventory: data?.pediatrictRBCJson?.inventory || '',
                                description: data?.pediatrictRBCJson?.description || ''
                            },
                            pltJson: {
                                o_POSCount: data?.pltJson?.o_POSCount || '',
                                o_NEGCount: data?.pltJson?.o_NEGCount || '',
                                a_POSCount: data?.pltJson?.a_POSCount || '',
                                a_NEGCount: data?.pltJson?.a_NEGCount || '',
                                b_POSCount: data?.pltJson?.b_POSCount || '',
                                b_NEGCount: data?.pltJson?.b_NEGCount || '',
                                aB_POSCount: data?.pltJson?.aB_POSCount || '',
                                aB_NEGCount: data?.pltJson?.aB_NEGCount || '',
                                sum: data?.pltJson?.sum || '',
                                inventory: data?.pltJson?.inventory || '',
                                description: data?.pltJson?.description || ''
                            },
                            lrpltJson: {
                                o_POSCount: data?.lrpltJson?.o_POSCount || '',
                                o_NEGCount: data?.lrpltJson?.o_NEGCount || '',
                                a_POSCount: data?.lrpltJson?.a_POSCount || '',
                                a_NEGCount: data?.lrpltJson?.a_NEGCount || '',
                                b_POSCount: data?.lrpltJson?.b_POSCount || '',
                                b_NEGCount: data?.lrpltJson?.b_NEGCount || '',
                                aB_POSCount: data?.lrpltJson?.aB_POSCount || '',
                                aB_NEGCount: data?.lrpltJson?.aB_NEGCount || '',
                                sum: data?.lrpltJson?.sum || '',
                                inventory: data?.lrpltJson?.inventory || '',
                                description: data?.lrpltJson?.description || ''
                            },
                            ffpJson: {
                                o_POSCount: data?.ffpJson?.o_POSCount || '',
                                o_NEGCount: data?.ffpJson?.o_NEGCount || '',
                                a_POSCount: data?.ffpJson?.a_POSCount || '',
                                a_NEGCount: data?.ffpJson?.a_NEGCount || '',
                                b_POSCount: data?.ffpJson?.b_POSCount || '',
                                b_NEGCount: data?.ffpJson?.b_NEGCount || '',
                                aB_POSCount: data?.ffpJson?.aB_POSCount || '',
                                aB_NEGCount: data?.ffpJson?.aB_NEGCount || '',
                                sum: data?.ffpJson?.sum || '',
                                inventory: data?.ffpJson?.inventory || '',
                                description: data?.ffpJson?.description || ''
                            },
                            cppJson: {
                                o_POSCount: data?.cppJson?.o_POSCount || '',
                                o_NEGCount: data?.cppJson?.o_NEGCount || '',
                                a_POSCount: data?.cppJson?.a_POSCount || '',
                                a_NEGCount: data?.cppJson?.a_NEGCount || '',
                                b_POSCount: data?.cppJson?.b_POSCount || '',
                                b_NEGCount: data?.cppJson?.b_NEGCount || '',
                                aB_POSCount: data?.cppJson?.aB_POSCount || '',
                                aB_NEGCount: data?.cppJson?.aB_NEGCount || '',
                                sum: data?.cppJson?.sum || '',
                                inventory: data?.cppJson?.inventory || '',
                                description: data?.cppJson?.description || ''
                            },
                            cryJson: {
                                o_POSCount: data?.cryJson?.o_POSCount || '',
                                o_NEGCount: data?.cryJson?.o_NEGCount || '',
                                a_POSCount: data?.cryJson?.a_POSCount || '',
                                a_NEGCount: data?.cryJson?.a_NEGCount || '',
                                b_POSCount: data?.cryJson?.b_POSCount || '',
                                b_NEGCount: data?.cryJson?.b_NEGCount || '',
                                aB_POSCount: data?.cryJson?.aB_POSCount || '',
                                aB_NEGCount: data?.cryJson?.aB_NEGCount || '',
                                sum: data?.cryJson?.sum || '',
                                inventory: data?.cryJson?.inventory || '',
                                description: data?.cryJson?.description || ''
                            },
                            specialRBCJson: {
                                radiatedCount: data?.specialRBCJson?.radiatedCount || '',
                                wahsedCount: data?.specialRBCJson?.wahsedCount || '',
                                cmV_NEGCount: data?.specialRBCJson?.cmV_NEGCount || '',
                                injectionDateTime: data?.specialRBCJson?.injectionDateTime ? moment(data?.specialRBCJson?.injectionDateTime) : null
                            },
                            specialPLTJson: {
                                radiatedCount: data?.specialPLTJson?.radiatedCount || '',
                                wahsedCount: data?.specialPLTJson?.wahsedCount || '',
                                pooledPLTCount: data?.specialPLTJson?.pooledPLTCount || '',
                                injectionDateTime: data?.specialPLTJson?.injectionDateTime ? moment(data?.specialPLTJson?.injectionDateTime) : null
                            },
                            otherSpecialProductJson: {
                                description: data?.otherSpecialProductJson?.description || '',
                                injectionDateTime: data?.otherSpecialProductJson?.injectionDateTime ? moment(data?.otherSpecialProductJson?.injectionDateTime) : null
                            }
                        }
                    });
                })
                .catch(message => {
                    console.log(message);
                    this.close();
                });
        }

        this.ref.modal.current.open();
    }

    print(data = {}) {
        const {props, state} = this;

        this.ref.modalPrint.current.open({
            title: 'چاپ',
            prints: [{
                id: 'sectionNormRequestForm',
                title: 'چاپ فرم درخواست از سازمان',
                count: 1,
                template: printerTemplate.INSERT_ORG_REQUEST,
                parameters: {
                    ProvinceStr: props.user?.provinceName,
                    CityStr: props.user?.cityName,
                    HospitalName: props.user?.hospitalFullName,
                    CreateDateTime: moment().format('jYYYY/jMM/jDD'),
                    WB_O_POS: data?.wbJson?.o_POSCount || '',
                    RBC_O_POS: data?.rbcJson?.o_POSCount || '',
                    LRBC_O_POS: data?.lrbcJson?.o_POSCount || '',
                    PediatrictRBC_O_POS: data?.pediatrictRBCJson?.o_POSCount || '',
                    PLT_O_POS: data?.pltJson?.o_POSCount || '',
                    LRPLT_O_POS: data?.lrpltJson?.o_POSCount || '',
                    FFP_O_POS: data?.ffpJson?.o_POSCount || '',
                    CPP_O_POS: data?.cppJson?.o_POSCount || '',
                    CRY_O_POS: data?.cryJson?.o_POSCount || '',
                    WB_O_NEG: data?.wbJson?.o_NEGCount || '',
                    RBC_O_NEG: data?.rbcJson?.o_NEGCount || '',
                    LRBC_O_NEG: data?.lrbcJson?.o_NEGCount || '',
                    PediatrictRBC_O_NEG: data?.pediatrictRBCJson?.o_NEGCount || '',
                    PLT_O_NEG: data?.pltJson?.o_NEGCount || '',
                    LRPLT_O_NEG: data?.lrpltJson?.o_NEGCount || '',
                    FFP_O_NEG: data?.ffpJson?.o_NEGCount || '',
                    CPP_O_NEG: data?.cppJson?.o_NEGCount || '',
                    CRY_O_NEG: data?.cryJson?.o_NEGCount || '',
                    WB_A_POS: data?.wbJson?.a_POSCount || '',
                    RBC_A_POS: data?.rbcJson?.a_POSCount || '',
                    LRBC_A_POS: data?.lrbcJson?.a_POSCount || '',
                    PediatrictRBC_A_POS: data?.pediatrictRBCJson?.a_POSCount || '',
                    PLT_A_POS: data?.pltJson?.a_POSCount || '',
                    LRPLT_A_POS: data?.lrpltJson?.a_POSCount || '',
                    FFP_A_POS: data?.ffpJson?.a_POSCount || '',
                    CPP_A_POS: data?.cppJson?.a_POSCount || '',
                    CRY_A_POS: data?.cryJson?.a_POSCount || '',
                    WB_A_NEG: data?.wbJson?.a_NEGCount || '',
                    RBC_A_NEG: data?.rbcJson?.a_NEGCount || '',
                    LRBC_A_NEG: data?.lrbcJson?.a_NEGCount || '',
                    PediatrictRBC_A_NEG: data?.pediatrictRBCJson?.a_NEGCount || '',
                    PLT_A_NEG: data?.pltJson?.a_NEGCount || '',
                    LRPLT_A_NEG: data?.lrpltJson?.a_NEGCount || '',
                    FFP_A_NEG: data?.ffpJson?.a_NEGCount || '',
                    CPP_A_NEG: data?.cppJson?.a_NEGCount || '',
                    CRY_A_NEG: data?.cryJson?.a_NEGCount || '',
                    WB_B_POS: data?.wbJson?.b_POSCount || '',
                    RBC_B_POS: data?.rbcJson?.b_POSCount || '',
                    LRBC_B_POS: data?.lrbcJson?.b_POSCount || '',
                    PediatrictRBC_B_POS: data?.pediatrictRBCJson?.b_POSCount || '',
                    PLT_B_POS: data?.pltJson?.b_POSCount || '',
                    LRPLT_B_POS: data?.lrpltJson?.b_POSCount || '',
                    FFP_B_POS: data?.ffpJson?.b_POSCount || '',
                    CPP_B_POS: data?.cppJson?.b_POSCount || '',
                    CRY_B_POS: data?.cryJson?.b_POSCount || '',
                    WB_B_NEG: data?.wbJson?.b_NEGCount || '',
                    RBC_B_NEG: data?.rbcJson?.b_NEGCount || '',
                    LRBC_B_NEG: data?.lrbcJson?.b_NEGCount || '',
                    PediatrictRBC_B_NEG: data?.pediatrictRBCJson?.b_NEGCount || '',
                    PLT_B_NEG: data?.pltJson?.b_NEGCount || '',
                    LRPLT_B_NEG: data?.lrpltJson?.b_NEGCount || '',
                    FFP_B_NEG: data?.ffpJson?.b_NEGCount || '',
                    CPP_B_NEG: data?.cppJson?.b_NEGCount || '',
                    CRY_B_NEG: data?.cryJson?.b_NEGCount || '',
                    WB_AB_POS: data?.wbJson?.aB_POSCount || '',
                    RBC_AB_POS: data?.rbcJson?.aB_POSCount || '',
                    LRBC_AB_POS: data?.lrbcJson?.aB_POSCount || '',
                    PediatrictRBC_AB_POS: data?.pediatrictRBCJson?.aB_POSCount || '',
                    PLT_AB_POS: data?.pltJson?.aB_POSCount || '',
                    LRPLT_AB_POS: data?.lrpltJson?.aB_POSCount || '',
                    FFP_AB_POS: data?.ffpJson?.aB_POSCount || '',
                    CPP_AB_POS: data?.cppJson?.aB_POSCount || '',
                    CRY_AB_POS: data?.cryJson?.aB_POSCount || '',
                    WB_AB_NEG: data?.wbJson?.aB_NEGCount || '',
                    RBC_AB_NEG: data?.rbcJson?.aB_NEGCount || '',
                    LRBC_AB_NEG: data?.lrbcJson?.aB_NEGCount || '',
                    PediatrictRBC_AB_NEG: data?.pediatrictRBCJson?.aB_NEGCount || '',
                    PLT_AB_NEG: data?.pltJson?.aB_NEGCount || '',
                    LRPLT_AB_NEG: data?.lrpltJson?.aB_NEGCount || '',
                    FFP_AB_NEG: data?.ffpJson?.aB_NEGCount || '',
                    CPP_AB_NEG: data?.cppJson?.aB_NEGCount || '',
                    CRY_AB_NEG: data?.cryJson?.aB_NEGCount || '',
                    WB_Sum: data?.wbJson?.sum || '',
                    RBC_Sum: data?.rbcJson?.sum || '',
                    LRBC_Sum: data?.lrbcJson?.sum || '',
                    PediatrictRBC_Sum: data?.pediatrictRBCJson?.sum || '',
                    PLT_Sum: data?.pltJson?.sum || '',
                    LRPLT_Sum: data?.lrpltJson?.sum || '',
                    FFP_Sum: data?.ffpJson?.sum || '',
                    CPP_Sum: data?.cppJson?.sum || '',
                    CRY_Sum: data?.cryJson?.sum || '',
                    WB_Inventory: data?.wbJson?.inventory || '',
                    RBC_Inventory: data?.rbcJson?.inventory || '',
                    LRBC_Inventory: data?.lrbcJson?.inventory || '',
                    PediatrictRBC_Inventory: data?.pediatrictRBCJson?.inventory || '',
                    PLT_Inventory: data?.pltJson?.inventory || '',
                    LRPLT_Inventory: data?.lrpltJson?.inventory || '',
                    FFP_Inventory: data?.ffpJson?.inventory || '',
                    CPP_Inventory: data?.cppJson?.inventory || '',
                    CRY_Inventory: data?.cryJson?.inventory || '',
                    WB_Desc: data?.wbJson?.description || '',
                    RBC_Desc: data?.rbcJson?.description || '',
                    LRBC_Desc: data?.lrbcJson?.description || '',
                    PediatrictRBC_Desc: data?.pediatrictRBCJson?.description || '',
                    PLT_Desc: data?.pltJson?.description || '',
                    LRPLT_Desc: data?.lrpltJson?.description || '',
                    FFP_Desc: data?.ffpJson?.description || '',
                    CPP_Desc: data?.cppJson?.description || '',
                    CRY_Desc: data?.cryJson?.description || '',
                    SpecialRBC_Radiated: data?.specialRBCJson?.radiatedCount || '',
                    SpecialRBC_Washed: data?.specialRBCJson?.wahsedCount || '',
                    SpecialRBC_CMV: data?.specialRBCJson?.cmV_NEGCount || '',
                    SpecialRBC_InjectionDateTime: data?.specialRBCJson?.injectionDateTime ? state?.fields?.specialRBCJson?.injectionDateTime.format('jYYYY/jMM/jDD') : null,
                    SpecialPLT_Radiated: data?.specialPLTJson?.radiatedCount || '',
                    SpecialPLT_Washed: data?.specialPLTJson?.wahsedCount || '',
                    SpecialPLT_Pooled: data?.specialPLTJson?.pooledPLTCount || '',
                    SpecialPLT_InjectionDateTime: data?.specialPLTJson?.injectionDateTime ? state?.fields?.specialPLTJson?.injectionDateTime.format('jYYYY/jMM/jDD') : null,
                    OtherSpecialProducts_Desc: data?.otherSpecialProductJson?.description || '',
                    OtherSpecialProducts_InjectionDateTime: data?.otherSpecialProductJson?.injectionDateTime ? state?.fields?.otherSpecialProductJson?.injectionDateTime.format('jYYYY/jMM/jDD') : null,
                    SenderFullName: this.props.user?.userFullName || ''
                }
            }]
        });
    }

    requestPrintOnSubmit(value) {
        this.props.updateBase({orgRequestFormPrintOnSubmit: value});
    }

    setInventory(products = this.state.inventory || {}) {
        const fields = {...this.state.fields};
        const check = (x, y) => {
            if (!x[y])
                x[y] = {inventory: 0};
            return x;
        };

        check(fields, 'wbJson').wbJson.inventory = products[1]?.count || '';
        check(fields, 'rbcJson').rbcJson.inventory = products[2]?.count || '';
        check(fields, 'lrbcJson').lrbcJson.inventory = products[3]?.count || '';
        check(fields, 'pediatrictRBCJson').pediatrictRBCJson.inventory = products[4]?.count || '';
        check(fields, 'pltJson').pltJson.inventory = products[5]?.count || '';
        check(fields, 'lrpltJson').lrpltJson.inventory = products[6]?.count || '';
        check(fields, 'ffpJson').ffpJson.inventory = products[7]?.count || '';
        check(fields, 'cppJson').cppJson.inventory = products[8]?.count || '';
        check(fields, 'cryJson').cryJson.inventory = products[9]?.count || '';

        this.setState({fields});
    }

    validate() {
        // let flag = true;

        // flag = ref.bloodSamplingTime.current.validate() === true && flag;

        return true;
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        base: state.base
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrgNormRequest);